import React, { useState } from 'react';
import { HiLockClosed, HiExternalLink } from 'react-icons/hi';
import { FaGithub } from 'react-icons/fa';
import project from './projects.json';

function Projects() {
    const [active, setActive] = useState('Professional');
    const filtered = project.filter(p => p.category === active && !p.hidden);

    const tabs = ['Professional', 'Personal'];

    return (
        <div id="project" className="bg-gray-50 py-16 px-4 sm:px-12 md:px-24">

            <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">
                My <span className="text-indigo-600">Projects</span>
                <br />
                <span className="w-8 h-1 bg-indigo-500 inline-block rounded-full mt-2" />
            </h2>

            {/* Filter Tabs */}
            <div className="flex justify-center gap-3 mb-10">
                {tabs.map(tab => (
                    <button
                        key={tab}
                        onClick={() => setActive(tab)}
                        className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 ${
                            active === tab
                                ? 'bg-indigo-600 text-white shadow-sm'
                                : 'bg-white text-gray-500 border border-gray-200 hover:border-indigo-300 hover:text-indigo-500'
                        }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                {filtered.map(post => (
                    <div
                        key={post.id}
                        className={`bg-white rounded-xl border ${post.featured ? 'border-indigo-200 shadow-md' : 'border-gray-100 shadow-sm'} hover:shadow-lg transition-shadow duration-300 p-6 flex flex-col`}
                        data-aos="fade-up"
                        data-aos-duration="1500"
                    >
                        {/* Header row */}
                        <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
                            <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-600">
                                {post.type}
                            </span>
                            <div className="flex items-center gap-2">
                                {post.featured && (
                                    <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-yellow-50 text-yellow-600">
                                        ★ Featured
                                    </span>
                                )}
                                {post.private && (
                                    <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-gray-100 text-gray-500 flex items-center gap-1">
                                        <HiLockClosed className="w-3 h-3" /> Private
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Title */}
                        <h3 className="text-base md:text-lg font-bold text-gray-900 mb-3">{post.name}</h3>

                        {/* Description */}
                        <p className="text-sm text-gray-600 leading-relaxed flex-1 mb-4">{post.description}</p>

                        {/* Tech pills */}
                        <div className="flex flex-wrap gap-1.5 mb-4">
                            {post.Technology.map((tech, i) => (
                                <span key={i} className="text-xs px-2.5 py-0.5 bg-indigo-50 text-indigo-700 rounded-full font-medium">
                                    {tech}
                                </span>
                            ))}
                        </div>

                        {/* Links — only shown if not private and at least one link exists */}
                        {!post.private && (post.repoLink || post.liveLink) && (
                            <div className="flex gap-4 pt-3 border-t border-gray-100">
                                {post.repoLink && (
                                    <a href={post.repoLink} target="_blank" rel="noreferrer"
                                        className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 hover:text-indigo-600 transition-colors">
                                        <FaGithub className="w-3.5 h-3.5" /> Repository
                                    </a>
                                )}
                                {post.liveLink && (
                                    <a href={post.liveLink} target="_blank" rel="noreferrer"
                                        className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 hover:text-indigo-600 transition-colors">
                                        <HiExternalLink className="w-3.5 h-3.5" /> Live Demo
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Projects;
